import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Property_Activities } from '../../../../../constants/APIs';

export default class PropertyActivities extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Property_Activities} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
